import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ─── ErrorBoundary: impede tela branca em qualquer dispositivo (mobile/iPad/desktop)
// Captura erros de qualquer componente filho e mostra fallback com botão de recarregar.
// Não interfere quando a app funciona normalmente.
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: "" };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    try {
      // eslint-disable-next-line no-console
      console.error("[AppErrorBoundary]", error, info && info.componentStack);
    } catch {}
    try { this.setState({ componentStack: (info && info.componentStack) || "" }); } catch {}
  }
  hardReload() {
    try {
      // Limpar caches/SW se existirem (Safari iOS pode ter cache agressiva)
      if (typeof caches !== "undefined" && caches.keys) {
        caches.keys().then(keys => Promise.all(keys.map(k => caches.delete(k)))).catch(() => {});
      }
      if (typeof navigator !== "undefined" && navigator.serviceWorker && navigator.serviceWorker.getRegistrations) {
        navigator.serviceWorker.getRegistrations().then(rs => rs.forEach(r => r.unregister())).catch(() => {});
      }
    } catch {}
    try { window.location.reload(); } catch {}
  }
  softReload() {
    try { window.location.reload(); } catch {}
  }
  render() {
    if (!this.state.hasError) return this.props.children;
    const e = this.state.error || {};
    const details = [
      "name: " + (e.name || "(none)"),
      "message: " + (e.message || "(empty)"),
      "toString: " + (function(){ try { return String(e); } catch { return "(throw)"; } })(),
      "stack:\n" + (e.stack || "(no stack)"),
      "componentStack:" + (this.state.componentStack || " (none)"),
      "ua: " + (typeof navigator !== "undefined" ? navigator.userAgent : "(no nav)"),
      "url: " + (typeof window !== "undefined" && window.location ? window.location.href : "(no loc)"),
      "time: " + new Date().toISOString(),
    ].join("\n\n");
    const copyDetails = () => {
      try { navigator.clipboard.writeText(details); alert("Detalhes copiados!"); }
      catch { try { window.prompt("Copia este texto:", details); } catch {} }
    };
    return (
      <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", padding:"24px 16px", fontFamily:"-apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif", background:"#f8f7f5", color:"#1a1a2e", boxSizing:"border-box" }}>
        <div style={{ maxWidth:520, width:"100%", background:"#fff", borderRadius:14, border:"1px solid #ece9e3", padding:"28px 24px", boxShadow:"0 4px 20px rgba(0,0,0,0.06)", textAlign:"center" }}>
          <div style={{ width:56, height:56, borderRadius:14, background:"#c8102e", color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontSize:26, fontWeight:900, margin:"0 auto 14px" }}>!</div>
          <h1 style={{ margin:"0 0 8px", fontSize:20, fontWeight:700, color:"#1a1a2e" }}>Ocorreu um erro a carregar a app</h1>
          <p style={{ margin:"0 0 18px", fontSize:14, color:"#6b7280", lineHeight:1.5 }}>Por favor recarrega a página. Se o problema persistir, tenta limpar a cache.</p>
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            <button onClick={() => this.softReload()} style={{ background:"#c8102e", color:"#fff", border:"none", borderRadius:10, padding:"12px 18px", fontSize:14, fontWeight:700, cursor:"pointer", minHeight:44 }}>↻ Recarregar página</button>
            <button onClick={() => this.hardReload()} style={{ background:"#fff", color:"#374151", border:"1px solid #e5e7eb", borderRadius:10, padding:"12px 18px", fontSize:13, fontWeight:600, cursor:"pointer", minHeight:44 }}>↺ Limpar cache e recarregar</button>
            <button onClick={copyDetails} style={{ background:"#1a1a2e", color:"#fff", border:"none", borderRadius:10, padding:"12px 18px", fontSize:13, fontWeight:600, cursor:"pointer", minHeight:44 }}>📋 Copiar detalhes técnicos</button>
          </div>
          <details style={{ marginTop:18, textAlign:"left" }} open>
            <summary style={{ cursor:"pointer", fontSize:11, color:"#9ca3af", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.04em" }}>Detalhes técnicos</summary>
            <pre style={{ marginTop:8, fontSize:10.5, color:"#374151", background:"#fafaf7", border:"1px solid #f1f1ee", borderRadius:8, padding:10, overflow:"auto", maxHeight:280, whiteSpace:"pre-wrap", wordBreak:"break-word" }}>{details}</pre>
          </details>
        </div>
      </div>
    );
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
